var lib_core = require("lib-core");

var showUI;
if(showUI = (typeof window !== 'undefined'))
    var ui_extensions = require("ui-extensions");

var Editor2DController = require("./editor2D/editor2DController.js");
var SelectionController = require("./selection/selectionController.js");
var CameraController = require("./camera2D/camera2DController.js");

var AbstractToolController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);
};
lib_core.inherit(AbstractToolController, lib_core.Controller);
if(showUI) {
    AbstractToolController.inject = {
        editor2DController    : Editor2DController,
        toolbarController     : ui_extensions.ToolbarController,
        toolbarModeController : ui_extensions.ToolbarModeController,
        selectionController   : SelectionController,
        cameraController      : CameraController
    };
} else {
    AbstractToolController.inject = {
        editor2DController   : Editor2DController,
        selectionController  : SelectionController,
        cameraController     : CameraController
    };
}
module.exports = AbstractToolController;

AbstractToolController.prototype.beforeLoad = function() {
    var self = this;

    lib_core.Controller.prototype.beforeLoad.call(this);

    if(this.parent() instanceof AbstractToolController) return;

    // TODO: this is a hacky way to call these functions with the right scope
    var enterFunction = function (cEvent) {
        var sm = self.getStatemachine();
        if(sm.enterFunction)
            sm.enterFunction.call(sm, cEvent);
    };
    var exitFunction = function (cEvent) {
        var sm = self.getStatemachine();
        if(sm.exitFunction)
            sm.exitFunction.call(sm, cEvent);
    };

    // tools can be part of a toolbar or part of a tray
    var toolbarMode = this.toolbarModeController;
    if (toolbarMode) {
        toolbarMode.registerTool(this);
    }

    var toolbar = this.toolbarController;
    if (toolbar) {
        var autoEscape = this.configuration.multiplePlacing ? false : true;
        var stateName = this.name();
        if(toolbarMode) stateName += "_"+toolbarMode.name();
        this.autoAppendArgs = [stateName, null, stateName, null];
        toolbar.registerTool(this, toolbarMode, autoEscape, enterFunction, exitFunction);
    }
};

AbstractToolController.prototype.createStateMachine = function () {
    var self = this;

    var editorModel     = this.editor2DController.getModel();
    var selectionModel  = this.selectionController.getModel();

    // scope is important here
    // we want to pass a function because the collection of a tool can sometimes
    // change dynamically while editing
    var getCollection = function () {
        return self.getCollection();
    };

    return new this.constructor.StateMachineClass(this.root, editorModel, selectionModel, getCollection, this.configuration, this.getModel());
};

AbstractToolController.prototype.getCollection = function () {
    var self = this;

    if(this.configuration.collection_configs){
        var collections = {};
        this.configuration.collection_configs.forEach(function(collection_config){
            var collection = self.root.findByPath(collection_config.collection);
            collections[collection.getName()] = collection;
        });
        return collections;
    }else{
        var collection = this.configuration["collection"];
        if(collection) return this.root.findByPath(collection);
        else return this.parent().getWrapCollection();
    }

};

AbstractToolController.prototype.getViewCollection = function () {
    // view collection is the same as the data collection for Tools
    return this.getCollection();
};

